import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class UpdateWorkflowsFailedError extends CodedError {
  static get errorName() {
    return errorCodeTypes.updateWorkflowsFailedError.code;
  }

  constructor(message = errorCodeTypes.updateWorkflowsFailedError.message) {
    super(message);
    this.code = errorCodeTypes.updateWorkflowsFailedError.code;
    this.message = `${message} ${errorCodeTypes.updateWorkflowsFailedError.code}`;
    this.name = errorCodeTypes.updateWorkflowsFailedError.name;
  }
}
